export const loadScript = (scriptId: string, url: string, async?: boolean, callback?: any, forceRelead?: boolean) => {
    const existingScript = document.getElementById(scriptId);

    if (forceRelead && existingScript)
    {
        document.body.removeChild(existingScript);
        setTimeout(function () {
            loadScript(scriptId, url, async, callback, forceRelead);
        }, 0);
        return;
    }
    if (!existingScript) {
        const script = document.createElement('script');

        if (async) {
            script.async = true;
        }
        script.src = url; // URL for the third-party library being loaded.
        script.id = scriptId; // e.g., googleMaps or stripe
        document.body.appendChild(script);

        script.onload = () => {
            if (callback) {
                callback();
            }
        };
    }

    if (existingScript && callback) {
        callback();
    }
};